var _defs, _g, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRsLengthWht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 325.23 198.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#eaeaea;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#1a1a1a;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -15.63,
    y1: 3.31,
    x2: 334.03,
    y2: 75.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#dddede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -26.05,
    y1: 53.79,
    x2: 323.6,
    y2: 126.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#dedfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 231.52,
    y1: 153.18,
    x2: -146.31,
    y2: 47.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.36 5.45 25.51 17.94 35.07 12.13 34.91 -0.35 25.36 5.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "34.99 -0.35 0 0 0.12 20.69 12.49 13.22 22.61 7.11 34.99 -0.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0.12 20.69 0.08 33.17 9.81 27.37 9.65 14.88 0.12 20.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "25.33 5.45 9.65 14.88 298.71 179.83 314.39 170.4 25.33 5.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.65 14.88 9.81 27.37 298.16 192.32 298.71 179.83 9.65 14.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "290.08 185.05 290.08 197.83 325.23 197.18 325.07 184.7 290.08 185.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "290.08 185.05 325.07 184.7 324.96 164.01 312.58 171.47 302.46 177.58 290.08 185.05"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132.83,47.74a11.77,11.77,0,0,1,.72,4v.66a6,6,0,0,1-.73,3.16,2.53,2.53,0,0,1-2,1.26,5.32,5.32,0,0,1-3-.84l-3.88-2.25,0-14.43,3.86,2.23a10.86,10.86,0,0,1,3,2.57A12.63,12.63,0,0,1,132.83,47.74ZM130.92,51v-.77a8.41,8.41,0,0,0-.79-3.79A5.71,5.71,0,0,0,127.82,44l-1.27-.74,0,9.63,1.25.72c1,.59,1.79.65,2.33.2a3.66,3.66,0,0,0,.82-2.78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145,51.44l0,9.51c0,1.57-.44,2.57-1.3,3s-2,.21-3.53-.65a9.84,9.84,0,0,1-3.49-3.35,8.46,8.46,0,0,1-1.31-4.44l0-9.62,2.59,1.5,0,9.53a4.64,4.64,0,0,0,.58,2.4,4.47,4.47,0,0,0,1.64,1.59q2.17,1.26,2.22-1.36l0-9.6Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "152.16 54.63 150.59 53.71 147.99 49.4 147.99 49.31 150.12 50.54 151.38 52.69 152.65 52 154.78 53.23 154.78 53.34 152.16 54.63"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "149.78 66.29 156.12 69.95 156.11 72.33 146.54 66.81 146.55 65.07 152.79 58.38 146.59 54.8 146.59 52.39 156.01 57.82 156.01 59.53 149.78 66.29"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "160.53 60.43 160.49 74.86 157.91 73.37 157.95 58.94 160.53 60.43"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "173.14 67.71 173.1 82.14 170.51 80.65 165.5 68.25 165.48 77.74 162.89 76.25 162.93 61.81 165.52 63.31 170.54 75.74 170.56 66.22 173.14 67.71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.57,72.58l4.66,17.14-2.75-1.59-.86-3.47L178.08,82l-.87,2.47-2.76-1.58,4.72-11.74ZM178.79,80l3.13,1.81-1.56-6.32L178.79,80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsLengthWht);
export default __webpack_public_path__ + "static/media/rs-length-wht.41e5525bad34cf8c2868815311dc8922.svg";
export { ForwardRef as ReactComponent };